var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sixteen wide column"},[_c('div',{staticClass:"ui left floated basic button",staticStyle:{"margin-top":"0.4em"},on:{"~click":function($event){return _vm.backOneLevel($event)}}},[_c('i',{staticClass:"long arrow alternate left icon"}),_vm._v("\n    Back to Main\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72bcd278","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavDetailsTop.vue
// module id = null
// module chunks = 